import React, { useCallback, useContext, useEffect, useState } from "react";
import { FaCheckCircle, FaClock, FaFilePdf, FaSearch } from "react-icons/fa";
import { useSearchResults } from "../context/SearchResultsContext";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { FaPencil, FaTrash, FaXmark } from "react-icons/fa6";
import RecoveryForm from "./recoveryForm";
import useAxios from "../common/hook/useAxios";
import { AuthContext } from "../context/AuthContext";
import Modal from "react-modal";
import DropdownWithPlaceholder from "./DropdownWithPlaceholder";
Modal.setAppElement("#root");
function DataTable({
  dataTableRef,
  labs,
  specimentTypesForDropdown,
  orderTypesForDropdown,
  selectedTemplate,
  uploadTriggered,
  selectedPatientRows,
  setSelectedPatientRows,
  handleSubmit,
  filteredData,
  suggestions,
  setSuggestions,
  handleSuggestionClick,
  handleDelete,
  selectedRows,
  setSelectedRows,
  handleSearch,
  checkbox,
}) {
  const rowsPerPage = 100;
  const { request } = useAxios();
  const { user } = useContext(AuthContext);
  const [selectedRequestRows, setSelectedRequestRows] = useState({});
  const [selectedPrintRows, setSelectedPrintRows] = useState({});
  const [selectAllPatients, setSelectAllPatients] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [values, setValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [patients, setPatients] = useState([]);
  const [searchPatient, setSearchPatient] = useState([]);
  const { results } = useSearchResults();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchCase, setSearchCase] = useState("");
  const [dob, setDob] = useState("");
  const [searchIns, setSearchIns] = useState("");
  const [searchProv, setSearchProv] = useState("");
  const [policy, setPolicy] = useState("");
  const [displayCount, setDisplayCount] = useState(100);
  const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
  const [sortConfig, setSortConfig] = useState({ key: null, order: null });
  const [searchOrderCode, setSearchOrderCode] = useState("");
  const [selectedLab, setSelectedLab] = useState("");
  const [selectedOrderType, setSelectedOrderType] = useState("");
  const [selectedSpecimenType, setSelectedSpecimenType] = useState("");
  const [searchPrev, setSearchPrev] = useState("");

  const [openReqModalRowId, setOpenReqModalRowId] = useState(null);
  const [openResultModalRowId, setOpenResultModalRowId] = useState(null);
  const [openPOCModalRowId, setOpenPOCModalRowId] = useState(null);
  useEffect(() => {
    if (filteredData && Array.isArray(filteredData)) {
      setPatients(
        filteredData?.map((item) => ({
          IntelliLabDetailsID: item.IntelliLabDetailsID,
          id: item.PatientID,
          caseNumber: item.ExternalCaseNumber,
          patientName: item.FirstName,
          patientLastName: item.LastName,
          dob: item?.DOB,
          collectionTime: item?.CollectionTime,
          insurance: item?.InsDetails,
          policyNumber: item?.PolicyNo,
          provider: item?.ProviderName,
          orderCode: item?.OrderCodes,
          ResultFileURL: item?.ResultFileURL,
          ReqFileURL: item?.ReqFileURL,
          ResultPDFName: item?.ResultPDFName,
          isOrderSubmitted: item?.IsOrderSubmitted,
          ReqPDFURL: item?.ReqPDFURL,
          icd: item?.ICDCodes,
          lab: item?.LabID,
          orderType: item?.OrderType,
          specimenTypeDesc: item?.SpecimenTypeDesc,
          specimenType: item?.SpecimenType,
          prevTest: item?.PrevTestDetails,
          appointmentDate: item?.AppointmentDate,
          MissingDataDetails: item.MissingDataDetails,
          ISavedFlag: item.ISavedFlag,
          Sex: item?.Sex,
          RequisitionNumber: item?.RequisitionNumber,
          Appointment_Date: item?.Appointment_Date,
          CellMainPhone: item?.CellMainPhone,
          MRN: item?.MRN,
          POCAddDetails: item?.POCAddDetails,
          POCFileURL: item?.POCFileURL,
        })),
      );
    }
  }, [results, filteredData]);

  const filterIntelli =
    patients &&
    Array.isArray(patients) &&
    patients?.filter((row) => {
      const fullName =
        `${row.patientName} ${row.patientLastName}`?.toLowerCase();
      const searchTermNormalized = searchTerm?.trim()?.toLowerCase();
      const dobMatches = row?.dob?.toLowerCase().includes(dob?.toLowerCase());
      const insMatches = row?.insurance
        ?.toLowerCase()
        .includes(searchIns?.toLowerCase());
      const provMatches = row?.provider
        ?.toLowerCase()
        .includes(searchProv?.toLowerCase());
      const policyMatches = row?.policyNumber
        ?.toLowerCase()
        .includes(policy?.toLowerCase());
      const prevTestMatches = row?.prevTest
        ?.toLowerCase()
        .includes(searchPrev?.toLowerCase());
      const orderTypeMatches = row?.orderCode
        ?.toLowerCase()
        .includes(searchOrderCode?.toLowerCase());
      const labMatches =
        selectedLab == 0
          ? true
          : selectedLab.toString() === row?.lab?.toString();
      const matchesSelectedOrderType =
        !selectedOrderType ||
        row.orderType?.toString() === selectedOrderType?.toString();
      const matchesSelectedSpecimenType =
        !selectedSpecimenType ||
        row.specimenType?.toString() === selectedSpecimenType?.toString();

      return (
        fullName.includes(searchTermNormalized) &&
        row?.caseNumber
          ?.trim()
          ?.toLowerCase()
          ?.startsWith(searchCase?.trim()?.toLowerCase()) &&
        dobMatches &&
        insMatches &&
        provMatches &&
        policyMatches &&
        labMatches &&
        matchesSelectedOrderType &&
        matchesSelectedSpecimenType &&
        prevTestMatches &&
        orderTypeMatches
      );
    });

  const loadMoreRecords = useCallback(() => {
    setVisibleRecords((prev) => Math.min(prev + rowsPerPage, patients.length));
  }, [patients.length]);

  const handleScroll = useCallback(() => {
    const isAtBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight;
    if (isAtBottom) {
      loadMoreRecords();
    }
  }, [loadMoreRecords]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const handlePatientRowSelect = (id) => {
    setSelectedPatientRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleSelectAll = () => {
    const newSelectedRows = {};
    if (Object.keys(selectedPatientRows).length === filterIntelli?.length) {
      setSelectedPatientRows({});
    } else {
      filterIntelli?.forEach((row) => {
        newSelectedRows[row?.IntelliLabDetailsID] = true;
      });
      setSelectedPatientRows(newSelectedRows);
    }
  };

  const handleAllForSendRequest = () => {
    const newSelectedRows = {};
    if (Object.keys(selectedRows)?.length === filterIntelli?.length) {
      setSelectedRows({});
    } else {
      filterIntelli?.forEach((row) => {
        newSelectedRows[row?.IntelliLabDetailsID] = true;
      });
      setSelectedRows(newSelectedRows);
    }
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const handlePrintRequest = () => {
    const selectedIds = Object.keys(selectedPrintRows).filter(
      (id) => selectedPrintRows[id],
    );
  };

  const searchPatients = async (inputVal) => {
    const url = `${process.env.REACT_APP_ORDER_CODE_URL}/Search/SearchPracticePatients?sJSONInput={"PracticeID":"${user?.PracticeID}","SearchKey":"${inputVal}","SearchBy":"0","isFromLogin":0}`;
    try {
      const res = await request({ url, method: "GET" });
      setSearchPatient(res.Data);
      return res.Data;
    } catch (err) {
      console.log(err);
      toast.error("Error occurred while searching patients", { autoClose: 3000 });
      return [];
    }
  };

  const handleInputChange = async (e) => {
    const value = e.target.value?.trim()?.toLowerCase();
    setInputValue(value);
    const searchedPatient = await searchPatients(value);
    if (value) {
      const filteredSuggestions = searchedPatient?.filter(
        (item) =>
          item.FirstName?.toLowerCase()?.includes(value) ||
          item.LastName?.toLowerCase()?.includes(value),
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleRecoveryForm = (
    orderType, lab, dob, patientId, firstName,
    providerName, requisitionNumber, collectionTime,
    sex, appointmentDate, CellMainPhone, iSavedFlag, MRN,
  ) => {
    setValues({
      orderType, lab, dob, patientId, firstName,
      providerName, requisitionNumber, collectionTime,
      sex, appointmentDate, CellMainPhone, iSavedFlag, MRN,
    });
    return setIsModal(true);
  };

  const handleRowClick = (rowId) => {
    setSelectedRow(rowId);
  };

  if (!results || results?.length == 0) {
    return (
      <div className="flex flex-col items-center justify-center p-6 bg-red-100 border border-red-300 rounded-lg shadow-md mx-auto my-8 w-full max-w-md">
        <h2 className="text-lg font-semibold text-red-700 mb-2">
          No Patients Available
        </h2>
        <p className="text-sm text-red-600 mb-4">
          There are currently no patients to display. Please search for patients
          from the search bar above and try changing the date.
        </p>
      </div>
    );
  }

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      order: prev.key === key && prev.order === "asc" ? "desc" : "asc",
    }));
  };

  const sortedData = [...filterIntelli].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
    const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
    return sortConfig.order === "asc"
      ? valueA.localeCompare(valueB)
      : valueB.localeCompare(valueA);
  });

  const toggleMenu = () => {
    setIsModal(false);
  };
  const PDFModal = ({ isOpen, onClose, src, label }) => (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={label}
      className={`absolute flex flex-col min-w-max top-8 right-4 w-4/5 bg-[#005d97] shadow-lg rounded-lg transition-transform duration-300 ease-in-out transform ${
        isOpen ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"
      }`}
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
    >
      <div className="modal-content">
        <div className="text-right">
          <FaXmark
            className="text-white cursor-pointer float-right bg-red-500 p-1 rounded-full text-2xl"
            onClick={onClose}
          />
        </div>
        {isOpen && (
          <iframe
            src={src}
            width="100%"
            height="600px"
            title={label}
          />
        )}
      </div>
    </Modal>
  );

  return (
    <>
      <RecoveryForm
        isModal={isModal}
        toggleMenu={toggleMenu}
        value={values}
        handleSearch={handleSearch}
      />
      <div ref={dataTableRef}>
        <table className="min-w-full bg-white border border-gray-300 table-fixed">
          <thead>
            <tr className="bg-[#005d97] border-b border-black text-white">
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                #
              </th>
              <th
                style={{ whiteSpace: "nowrap", position: "sticky", left: 0, zIndex: 10 }}
                className="p-2 border-r border-black bg-[#005d97] cursor-pointer"
              >
                DOS <br />Collection <br />Date
                <span onClick={() => handleSort(formatDate("appointmentDate"))}>
                  {sortConfig.key === "appointmentDate"
                    ? sortConfig.order === "asc" ? "▲" : "▼"
                    : ""}
                </span>
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97] cursor-pointer underline">
                <span onClick={() => handleSort("caseNumber")}>
                  Case{" "}
                  {sortConfig.key === "caseNumber"
                    ? sortConfig.order === "asc" ? "▲" : "▼"
                    : ""}
                </span>
                <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-full"
                  placeholder="Search"
                  value={searchCase}
                  onChange={(e) => setSearchCase(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th
                style={{ whiteSpace: "nowrap", position: "sticky", left: "100px", zIndex: 10 }}
                className="p-2 border-r border-black bg-[#005d97] cursor-pointer underline"
              >
                <span onClick={() => handleSort("patientLastName")}>
                  Patient Name{" "}
                  {sortConfig.key === "patientLastName"
                    ? sortConfig.order === "asc" ? "▲" : "▼"
                    : ""}
                </span>
                <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-4/5"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97] cursor-pointer underline">
                <span onClick={() => handleSort("dob")}>
                  DOB{" "}
                  {sortConfig.key === "dob"
                    ? sortConfig.order === "asc" ? "▲" : "▼"
                    : ""}
                </span>
                <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
                  placeholder="Search"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                Insurance <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
                  placeholder="Search"
                  value={searchIns}
                  onChange={(e) => setSearchIns(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97] cursor-pointer underline">
                <span onClick={() => handleSort("policyNumber")}>
                  Policy#
                  {sortConfig.key === "policyNumber"
                    ? sortConfig.order === "asc" ? "▲" : "▼"
                    : ""}
                </span>
                <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
                  placeholder="Search"
                  value={policy}
                  onChange={(e) => setPolicy(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97] cursor-pointer underline">
                <span onClick={() => handleSort("provider")}>
                  Provider
                  {sortConfig.key === "provider"
                    ? sortConfig.order === "asc" ? "▲" : "▼"
                    : ""}
                </span>
                <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
                  placeholder="Search"
                  value={searchProv}
                  onChange={(e) => setSearchProv(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                Collection<br />Time
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                Order Codes <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
                  placeholder="Search"
                  value={searchOrderCode}
                  onChange={(e) => setSearchOrderCode(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                ICD
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border bg-[#005d97]">
                Lab
                <DropdownWithPlaceholder
                  items={labs}
                  label="Lab"
                  selectedValue={selectedLab}
                  setSelectedValue={setSelectedLab}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border bg-[#005d97]">
                Order Type
                <DropdownWithPlaceholder
                  items={orderTypesForDropdown}
                  label="Order Type"
                  selectedValue={selectedOrderType}
                  setSelectedValue={setSelectedOrderType}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                Specimen Type
                <DropdownWithPlaceholder
                  items={specimentTypesForDropdown}
                  label="Specimen Type"
                  selectedValue={selectedSpecimenType}
                  setSelectedValue={setSelectedSpecimenType}
                />
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                Prev Test <br />
                <input
                  type="text"
                  className="text-gray-800 text-sm mt-1 hide-on-print w-11/12"
                  placeholder="Search"
                  value={searchPrev}
                  onChange={(e) => setSearchPrev(e.target.value)}
                  style={{ marginBottom: "10px", padding: "5px" }}
                />
              </th>
              {Array.isArray(checkbox) && checkbox?.includes("POC") && (
                <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                  POC
                </th>
              )}
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border bg-[#005d97]">
                <button className="bg-orange text-white px-4 py-2 rounded transition-colors">
                  Print Request
                </button>
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                <button className="bg-orange text-white px-4 py-2 rounded transition-colors">
                  Print Result
                </button>
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                <div className="flex items-center space-x-2">
                  <button
                    onClick={handleSubmit}
                    className="bg-orange text-white px-4 py-2 rounded transition-colors"
                  >
                    Send Request
                  </button>
                  <input
                    type="checkbox"
                    checked={Object.keys(selectedRows).length === filterIntelli?.length}
                    onChange={handleAllForSendRequest}
                  />
                </div>
              </th>
              <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black bg-[#005d97]">
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={Object.keys(selectedPatientRows).length === filterIntelli?.length}
                    onChange={handleSelectAll}
                  />
                  <FaTrash className="cursor-pointer" onClick={handleDelete} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr key={"unique-data"} className="border-b border-black bg-blue-100">
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                {formatDate(new Date())}
              </td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Add Patient"
                    value={inputValue}
                    onChange={handleInputChange}
                    className="pl-8 pr-4 py-2 border rounded-md w-full hide-on-print"
                  />
                  <FaSearch className="absolute top-1/2 left-2 transform -translate-y-1/2 text-gray-500" />
                  {suggestions?.length > 0 && (
                    <ul className="absolute top-full left-0 w-full bg-white border border-gray-300 mt-1 max-h-60 overflow-auto z-10">
                      {suggestions?.map((suggestion) => (
                        <li
                          key={suggestion.id}
                          style={{ whiteSpace: "nowrap" }}
                          className="p-2 cursor-pointer hover:bg-gray-200"
                          onClick={() => handleSuggestionClick(suggestion)}
                        >
                          {suggestion.LastName}, {suggestion.FirstName}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
              <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black"></td>
            </tr>

            {sortedData
              ?.slice(0, visibleRecords)
              ?.map((row, index) => (
                <tr
                  key={index + 1}
                  className={`border-b border-black bg-[#cbf59b] font-medium text-md ${
                    row.MissingDataDetails.length > 0 && "bg-red-400"
                  } ${row.ISavedFlag != 0 && "bg-yellow-400"} ${
                    selectedRow === row.id && "bg-yellow-100"
                  } ${row.isOrderSubmitted === 1 && "bg-gray-300"}`}
                  data-tooltip-content={
                    row.MissingDataDetails.length > 0 ? row.MissingDataDetails : ""
                  }
                  onClick={() => handleRowClick(row.id)}
                  data-tooltip-id={
                    row.MissingDataDetails.length > 0 ? `tooltip-${row.id}` : undefined
                  }
                  data-tooltip-place="top"
                >
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {index + 1}
                  </td>
                  <td
                    style={{ position: "sticky", left: 0, background: "lightblue", zIndex: 5 }}
                    className="p-2 border-r border-black"
                  >
                    {formatDate(new Date(row.appointmentDate))}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.caseNumber}
                  </td>
                  <td
                    style={{ position: "sticky", left: "100px", background: "lightblue", zIndex: 5 }}
                    className="p-2 border-r border-b border-black cursor-pointer text-blue-700 underline"
                    onClick={() => {
                      const url = `/patient-dashboard?patientId=${row?.id}&patientName=${encodeURIComponent(row?.patientName + row?.patientLastName)}`;
                      window.open(url, "_blank");
                    }}
                  >
                    {`${row?.patientLastName || ""}, ${row?.patientName || ""}`}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.dob}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.insurance}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.policyNumber}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row?.provider}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    <div className="flex justify-between items-center">
                      <div>{row.collectionTime}</div>
                      <div>
                        <FaClock className="text-gray-500 text-xl hide-on-print" />
                      </div>
                    </div>
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row?.orderCode}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.icd}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {labs.filter((item) => item?.value.toString() == row?.lab.toString())[0]
                      ?.label.split(" ")[0] ?? "-"}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {orderTypesForDropdown.filter(
                      (item) => item.value.toString() == row.orderType.toString()
                    )[0]?.label.slice(0, 3)}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.specimenTypeDesc}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row.prevTest}
                  </td>

                  {/* POC Column */}
                  {Array.isArray(checkbox) && checkbox?.includes("POC") && (
                    <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                      {row.POCAddDetails}
                      {row?.POCFileURL !== "" && (
                        <>
                          <FaFilePdf
                            // FIX: use row-specific ID instead of shared boolean
                            onClick={() => setOpenPOCModalRowId(row.IntelliLabDetailsID)}
                            className="cursor-pointer text-red-400"
                          />
                          <PDFModal
                            isOpen={openPOCModalRowId === row.IntelliLabDetailsID}
                            onClose={() => setOpenPOCModalRowId(null)}
                            src={row?.POCFileURL}
                            label="POC PDF Viewer"
                          />
                        </>
                      )}
                    </td>
                  )}

                  {/* Print Request Column */}
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row?.isOrderSubmitted === 1 && (
                      <>
                        <FaFilePdf
                          // FIX: use row-specific ID instead of shared boolean
                          onClick={() => setOpenReqModalRowId(row.IntelliLabDetailsID)}
                          className="cursor-pointer text-red-400"
                        />
                        <PDFModal
                          isOpen={openReqModalRowId === row.IntelliLabDetailsID}
                          onClose={() => setOpenReqModalRowId(null)}
                          src={row?.ReqFileURL}
                          label="Request PDF Viewer"
                        />
                      </>
                    )}
                  </td>

                  {/* Print Result Column */}
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    {row?.orderType === "75" && row?.ISavedFlag === 0 && row?.caseNumber ? (
                      <FaPencil
                        onClick={() =>
                          handleRecoveryForm(
                            row?.orderType,
                            row?.lab,
                            row?.dob,
                            row?.id,
                            row?.patientLastName + ", " + row?.patientName,
                            row?.provider,
                            row?.RequisitionNumber,
                            row?.collectionTime,
                            row?.Sex,
                            formatDate(new Date(row?.appointmentDate)),
                            row?.CellMainPhone,
                            row?.ISavedFlag,
                            row?.MRN,
                          )
                        }
                        className="cursor-pointer"
                      />
                    ) : (
                      row?.ResultPDFName !== "" && (
                        <>
                          <FaFilePdf
                            // FIX: use row-specific ID instead of shared boolean
                            onClick={() => setOpenResultModalRowId(row.IntelliLabDetailsID)}
                            className="cursor-pointer text-red-400"
                          />
                          <PDFModal
                            isOpen={openResultModalRowId === row.IntelliLabDetailsID}
                            onClose={() => setOpenResultModalRowId(null)}
                            src={row?.ResultFileURL}
                            label="Result PDF Viewer"
                          />
                        </>
                      )
                    )}
                  </td>

                  {/* Send Request Column */}
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    <div className="flex flex-row items-center justify-between">
                      {row?.isOrderSubmitted === 1 ? (
                        <FaCheckCircle className="cursor-pointer text-green-500" />
                      ) : (
                        <div></div>
                      )}
                      <input
                        disabled={row.MissingDataDetails.length > 0}
                        type="checkbox"
                        checked={!!selectedRows[row.IntelliLabDetailsID]}
                        onChange={() => handleRowSelect(row.IntelliLabDetailsID)}
                      />
                    </div>
                  </td>

                  {/* Delete Column */}
                  <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r border-black">
                    <input
                      type="checkbox"
                      checked={!!selectedPatientRows[row.IntelliLabDetailsID]}
                      onChange={() => handlePatientRowSelect(row.IntelliLabDetailsID)}
                    />
                  </td>

                  <Tooltip id={`tooltip-${row.id}`} />
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export function getCurrentTime(is24HourFormat = false) {
  const now = new Date();
  let hours = now.getHours();
  const minutes = now.getMinutes();

  if (is24HourFormat) {
    hours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}:${paddedMinutes}`;
  } else {
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}:${paddedMinutes} ${period}`;
  }
}

export default DataTable;
